import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import DocumentsFoldersListItem from 'app/main/pages/documents-structure/DocumentsFoldersListItem';
import CommunicationsListItem from 'app/main/modules/communications/CommunicationsListItem';

import GroupsDetailsTab from './tabs/GroupsDetailsTab';

import GroupsUsersListItem from '../groups-users/GroupsUsersListItem';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <GroupsDetailsTab {...props} />
	},
	{
		id: 'users',
		title: 'TAB_GROUPS_USERS',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'users'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="groups_users"
				content={{ type: 'list', itemLayout: GroupsUsersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'grus_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'communications',
		title: 'MODULE_COMMUNICATIONS_NAME',
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('communications') || authorizer.cannot('view', 'communications'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="communications_groups"
				content={{ type: 'list', itemLayout: CommunicationsListItem, id: 'communicationsView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		),
		disabled: ({ isEdit }) => isEdit
	},
	{
		id: 'documents-folders',
		title: 'MODULE_SYS_DOCUMENTS_FOLDERS_NAME',
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('sys_documents_folders') || authorizer.cannot('view', 'sys_documents_folders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="sys_documents_folders"
				content={{ type: 'list', itemLayout: DocumentsFoldersListItem, id: 'documentsfoldersView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		),
		disabled: ({ isEdit }) => isEdit
	}
];

export default tabs;
